import _slicedToArray from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import classNames from 'classnames';
import CSSMotion from 'rc-motion';
import { render, unmount } from "rc-util/es/React/render";
import raf from "rc-util/es/raf";
import * as React from 'react';
import { getTargetWaveColor } from './util';

function validateNum(value) {
  return Number.isNaN(value) ? 0 : value;
}

var WaveEffect = function WaveEffect(props) {
  var className = props.className,
      target = props.target;
  var divRef = React.useRef(null);

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      color = _React$useState2[0],
      setWaveColor = _React$useState2[1];

  var _React$useState3 = React.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      borderRadius = _React$useState4[0],
      setBorderRadius = _React$useState4[1];

  var _React$useState5 = React.useState(0),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      left = _React$useState6[0],
      setLeft = _React$useState6[1];

  var _React$useState7 = React.useState(0),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      top = _React$useState8[0],
      setTop = _React$useState8[1];

  var _React$useState9 = React.useState(0),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      width = _React$useState10[0],
      setWidth = _React$useState10[1];

  var _React$useState11 = React.useState(0),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      height = _React$useState12[0],
      setHeight = _React$useState12[1];

  var _React$useState13 = React.useState(false),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      enabled = _React$useState14[0],
      setEnabled = _React$useState14[1];

  var waveStyle = {
    left: left,
    top: top,
    width: width,
    height: height,
    borderRadius: borderRadius.map(function (radius) {
      return "".concat(radius, "px");
    }).join(' ')
  };

  if (color) {
    waveStyle['--wave-color'] = color;
  }

  function syncPos() {
    var nodeStyle = getComputedStyle(target); // Get wave color from target

    setWaveColor(getTargetWaveColor(target));
    var isStatic = nodeStyle.position === 'static'; // Rect

    var borderLeftWidth = nodeStyle.borderLeftWidth,
        borderTopWidth = nodeStyle.borderTopWidth;
    setLeft(isStatic ? target.offsetLeft : validateNum(-parseFloat(borderLeftWidth)));
    setTop(isStatic ? target.offsetTop : validateNum(-parseFloat(borderTopWidth)));
    setWidth(target.offsetWidth);
    setHeight(target.offsetHeight); // Get border radius

    var borderTopLeftRadius = nodeStyle.borderTopLeftRadius,
        borderTopRightRadius = nodeStyle.borderTopRightRadius,
        borderBottomLeftRadius = nodeStyle.borderBottomLeftRadius,
        borderBottomRightRadius = nodeStyle.borderBottomRightRadius;
    setBorderRadius([borderTopLeftRadius, borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius].map(function (radius) {
      return validateNum(parseFloat(radius));
    }));
  }

  React.useEffect(function () {
    if (target) {
      // We need delay to check position here
      // since UI may change after click
      var id = raf(function () {
        syncPos();
        setEnabled(true);
      }); // Add resize observer to follow size

      var resizeObserver;

      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(syncPos);
        resizeObserver.observe(target);
      }

      return function () {
        raf.cancel(id);
        resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
      };
    }
  }, []);

  if (!enabled) {
    return null;
  }

  return /*#__PURE__*/React.createElement(CSSMotion, {
    visible: true,
    motionAppear: true,
    motionName: "wave-motion",
    motionDeadline: 5000,
    onAppearEnd: function onAppearEnd(_, event) {
      var _a;

      if (event.deadline || event.propertyName === 'opacity') {
        var holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        unmount(holder).then(function () {
          holder === null || holder === void 0 ? void 0 : holder.remove();
        });
      }

      return false;
    }
  }, function (_ref) {
    var motionClassName = _ref.className;
    return /*#__PURE__*/React.createElement("div", {
      ref: divRef,
      className: classNames(className, motionClassName),
      style: waveStyle
    });
  });
};

export default function showWaveEffect(node, className) {
  // Create holder
  var holder = document.createElement('div');
  holder.style.position = 'absolute';
  holder.style.left = "0px";
  holder.style.top = "0px";
  node === null || node === void 0 ? void 0 : node.insertBefore(holder, node === null || node === void 0 ? void 0 : node.firstChild);
  render( /*#__PURE__*/React.createElement(WaveEffect, {
    target: node,
    className: className
  }), holder);
}